
import { ICON_BASE_PATH } from "@/app/utils/config";
import { gxGetErrorMessage } from "@/app/utils/error/errorHelper";

interface RequiredMessageProps {
  message?: string | null;
  errorCode?: string | number | null;
  /** NEW: optional per-field breakdown, rendered under the main message. */
  details?: { fieldName: string; message: string }[];
}

const RequiredMessage: React.FC<RequiredMessageProps> = ({
  message,
  errorCode,
  details = [],
}) => {
  const displayMessage = errorCode
    ? gxGetErrorMessage(errorCode, "title")
    : message;

  // NEW: still render when there is no top-level message but we do have
  // field-level details to show.
  if (!displayMessage && details.length === 0) return null;

  return (
    <div className="gx-required-message">
      <img src={`${ICON_BASE_PATH}requiredicon.svg`} alt="requiredicon" />

      <div className="gx-required-message-body">
        {displayMessage && <p className="gx-p14-md">{displayMessage}</p>}

        {details.length > 0 && (
          <ul className="gx-required-message-list">
            {details.map((detail) => (
              <li key={detail.fieldName} className="gx-p12-r">
                <strong>{detail.fieldName}</strong>: {detail.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default RequiredMessage;